import { Container } from './styles';

interface LineDateProps {
  date: Date;
}

export function LineDate({ date }: LineDateProps) {
  return (
    <Container>
      <div />
      <p>
        {new Date(date).toLocaleDateString('pt-BR', {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
        })}
      </p>
      <div />
    </Container>
  );
}
